export enum QueryParams {
  FILTER = 'filter',
  ID = 'id',
  SELECTED_PROVIDER = 'selectedProvider',
  TEMPLATE_ID = 'templateId',
  TEMPLATE_NAME = 'templateName',
  HTTP_REFERRER = 'http_referrer',
  RETURNED_FROM_LOGIN_PAGE = 'returnedFromLoginPage',
}
